<template>
    <footer class="home_footer" v-cloak>
      <div class="footer">
        <!-- <div class="footer-content u-flex u-flex-between">
          <div class="footer-head">
              <h4>公司简介</h4>
              <ul class="footer-list">
                  <li><a href="#">主要信息</a></li>
                  <li><a href="#">组织结构 </a></li>
                  <li><a href="#">公司能力</a></li>
              </ul>
          </div>
          <div class="footer-head">
              <h4>产业与服务</h4>
              <ul class="footer-list">
                  <li><a href="#">华为</a></li>
                  <li><a href="#">中国移动 </a></li>
                  <li><a href="#">中国电信</a></li>
              </ul>
          </div>
          <div class="footer-head">
              <h4>解决方案</h4>
              <ul class="footer-list">
                  <li><a href="#">呼兰数据中心</a></li>
                  <li><a href="#">南汇 IDC</a></li>
                  <li><a href="#">周浦 IDC</a></li>
              </ul>
          </div>
          <div class="footer-head">
              <h4>SDWAN</h4>
              <ul class="footer-list">
                  <li><a href="#">渣打银行</a></li>
                  <li><a href="#">大众汽车</a></li>
                  <li><a href="#">MARVELL</a></li>
              </ul>
          </div>
          <div class="footer-head">
              <h4>联系我们</h4>
              <ul class="footer-list">
                  <li><a href="#">上海分公司</a></li>
                  <li><a href="#">北京分公司</a></li>
                  <li><a href="#">美国分公司</a></li>
              </ul>
          </div>
        </div> -->
        <div class="footer-area-bottom">
          <div class="u-flex u-flex-between">
              <p class="copyright">Copyright &copy; 2024 Global Global Kft. All rights reserved.</p>
              <!-- <a href="#" class="bei">{{ $t('xdata.Foot_bei') }}</a> -->
              <p class="phone">{{ $t('xdata.Foot_phone') }}: +86-021-61103898</p>    
          </div>
        </div>
      </div>
    </footer>
</template>


<script>
export default {
  name: "home_footer",
  data() {
    return {
      msg: "",
      lang:''
    };
  },
  created(){
    this.lang = localStorage.getItem('lang') 
  },
};
</script>

<style scoped>
.home_footer{
  background: #222222;
  padding-bottom: 30px;
}
.footer{
  width: 1200px;
  margin: 0 auto;
}
.footer-content .footer-head{
  width: 25%;
}
.footer-content .footer-head h4{
  color: #fff;
  margin-bottom: 12px;
  font-size: 20px;
  text-align: center;
}
.footer-content .footer-head li{
  margin-bottom: 8px;
  text-align: center;
}
.footer-content .footer-head li a{
  color: #fff;
  transition: color 0.3s;
  font-size: 14px;
}
.footer-content .footer-head li a:hover{
  color: #009DE4;
}
.footer-area-bottom{
  padding-top: 20px;
  border-top: 1px solid #2f2f2f;
}
.copyright{
  font-size: 12px;
  color: #fff;
  width: 50%;
  text-align: center;
}
.bei{
  font-size: 12px;
  color: #fff;
  width: 25%;
  text-align: center;
  text-decoration: none;
  transition: color 0.3s;
}
.bei:hover{
  color: #009DE4;
}
.phone{
  font-size: 12px;
  width: 25%;
  text-align: center;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue